<div
  #timeDropdownContainer
  rtScrollable
  [class.dark]="dark"
  [style.maxHeight]="maxHeight + 'px'"
  class="time-dropdown"
>
  <div
    *ngFor="let time of state.timesArr; let i = index; trackBy: trackBy"
    (click)="onTimeSelect(i)"
    [class.active]="i === state.selectionIndex"
    #timeItemsQuery
    class="time-dropdown-item"
  >
    <span>{{ time }}</span>
  </div>
</div>
